import moment from 'moment'
export function gmtStringToString(gmtString, showWeek = false, format = 'YYYY-MM-DD HH:mm:ss') {
  if (gmtString === null || gmtString === undefined) {
    return ''
  }
  // var date = gmtString.slice(0, -6)
  let momentObj = moment(gmtString)
  var dateString = momentObj.format(format)
  let week = num2Week(momentObj.day())
  if (showWeek) {
    return dateString + ' ' + week
  } else {
    return dateString
  }
}
export function movesMessage(status) {
  const code = status.code
  const name = status.name
  if (name !== null) {
    return name
  }
  if (code === 'MOS') {
    return 'Empty to shipper'
  }
  if (code === 'XRX') {
    return 'Ready to Load at port'
  }
  if (code === 'ETA_LOAD') {
    return 'Departure'
  }
  if (code === 'ETA_FINAL_DISCHARGE') {
    return 'Arrival final port of discharge'
  }
  return code
}

export function timestamp2String(timestamp, format) {
  let momentObj = moment(timestamp * 1000)
  var dateString = momentObj.format(format)
  // 如果包含星期
  if (dateString.indexOf('周') >= 0) {
    let index = dateString.indexOf('周')
    let week = num2Week(momentObj.day())
    dateString = dateString.substring(0, index) + week + dateString.substring(index + 2)
    console.log('dateString = ', dateString)
  }
  return dateString
}
function num2Week(week) {
  switch (week) {
    case 1:
      return '周一'
    case 2:
      return '周二'
    case 3:
      return '周三'
    case 4:
      return '周四'
    case 5:
      return '周五'
    case 6:
      return '周六'
    case 0:
      return '周日'
  }
}
export function containerText(type) {
  if (type === '22G1') {
    return "小箱 20'GP"
  }
  if (type === '42G1') {
    return "平箱 40'GP"
  }
  if (type === '45G1') {
    return "高箱 40'HQ"
  }
  return type
}



// WEBPACK FOOTER //
// ./src/filters/index.js